import UserApi from "./SecurityApi";
import { jwtDecode } from "jwt-decode";
import {
  TOKEN_IDENTIFICATION,
  PLANT_ID,
  COMPANY_ID,
} from "../utilities/util";

// Não precisamos mais obter o token do localStorage, pois ele está nos cookies HttpOnly
export const getToken = (): any => null;

export const getTokenDecoded = (token: string): any => {
  if (token !== null && token !== undefined && token !== "undefined") {
    return jwtDecode(token);
  }
  return null;
};

const removeAuthFootprint = (): void => {
  // Remove dados persistidos que sinalizam sessão ativa
  localStorage.removeItem(TOKEN_IDENTIFICATION);
  localStorage.removeItem(PLANT_ID);
  localStorage.removeItem(COMPANY_ID);
};

export const validadeToken = (): boolean => {
  // Considera sessão válida somente quando os identificadores mínimos existem
  const userId = localStorage.getItem(TOKEN_IDENTIFICATION);
  const plantId = localStorage.getItem(PLANT_ID);
  return Boolean(userId && plantId);
};

export const isAuthenticated = (): boolean => validadeToken();

let redirectingToLogin = false;

type LogoutOptions = {
  redirectTo?: string;
  callServer?: boolean;
  onRedirect?: (path: string) => void;
  useBeacon?: boolean;
};

export const logout = (options?: LogoutOptions): void => {
  const redirectPath = options?.redirectTo ?? "/login";
  const shouldNotifyServer = options?.callServer ?? false;
  const onRedirect = options?.onRedirect;
  const preferBeacon = options?.useBeacon ?? false;

  if (redirectingToLogin) {
    return;
  }

  redirectingToLogin = true;
  removeAuthFootprint();

  const finalizeRedirect = (): void => {
    // Garante redirecionamento consistente sempre que a sessão for invalidada
    if (typeof onRedirect === "function") {
      onRedirect(redirectPath);
    } else if (window.location.pathname !== redirectPath) {
      window.location.replace(redirectPath);
    }
    redirectingToLogin = false;
  };

  if (!shouldNotifyServer) {
    finalizeRedirect();
    return;
  }

  if (preferBeacon && typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
    UserApi.LogoutBeacon();
    finalizeRedirect();
    return;
  }

  UserApi.Logout()
    .catch((error) => console.error("Erro ao fazer logout:", error))
    .finally(finalizeRedirect);
};
